import TradeAccountRequest from './components/TradeAccountRequest';

// The multi-step trade application form now lives on the trade portal
// (hertex-trade-ui), behind the applicant lock. On the consumer site the
// /register page only captures an email and routes the person to trade login
// (account exists) or applicant activation (no account yet).
function RegistrationPage() {
  return <TradeAccountRequest />;
}
export default RegistrationPage;
